import { useState } from 'react';
import { FILL, Tab, Tabs } from 'baseui/tabs-motion';
import { ScrollToTopButton } from '@gtintel/platform-atoms';
import ContentContainer from '../ContentContainer';
import QualityInsights from '../QualityInsights';
import { QA_DASHBOARD_ID } from '../constants';
import QATrackerTable from './QATrackerTable';
function QATracker() {
  const [activeKey, setActiveKey] = useState('0');
  return <ContentContainer>
      <Tabs activeKey={activeKey} onChange={({
      activeKey
    }) => {
      setActiveKey(activeKey.toString());
    }} activateOnFocus fill={FILL.fixed} overrides={{
      Root: {
        style: {
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }
      }
    }}>
        <Tab title="Analysis">
          <QualityInsights dashboardId={QA_DASHBOARD_ID} styles={{
          height: '90vh'
        }} />
        </Tab>
        <Tab title="Assignment">
          <QATrackerTable />
        </Tab>
      </Tabs>
      <ScrollToTopButton />
    </ContentContainer>;
}
export default QATracker;